/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Pin } from 'src/app/_model/pin';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class PinsDaoService implements Resetable {
  public abstract savePins(pins: Pin[]): Promise<void>;
  public abstract createPin(pin: Pin): Promise<Pin>;
  public abstract getPins(): Promise<Pin[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
